import TagManager from "react-gtm-module";

const DEFAULT_GTM_ID = "GTM-N8886PX";
export function gtmInit(tagManagerArgs = null) {
  tagManagerArgs =
    !tagManagerArgs || !tagManagerArgs?.gtmId
      ? {
          gtmId: DEFAULT_GTM_ID,
        }
      : tagManagerArgs;

  TagManager.initialize(tagManagerArgs);
}

export const gtmSendDatalayer = (data) => TagManager.dataLayer(data);

export function gtmSendTCODatalayerClick(
  pageLocation,
  tcoValue,
  timestamp = null
) {
  gtmSendDatalayer({
    dataLayer: {
      event: "tco_detalhar_clicked",
      page_location: pageLocation,
      tco_value: tcoValue,
      timestamp: timestamp == null ? new Date().getTime() : timestamp,
    },
  });
}

export function gtmSendTCODatalayerRedirect(
  pageLocation,
  eventPrefix,
  keyName,
  keyValue,
  timestamp = null
) {
  gtmSendDatalayer({
    dataLayer: {
      event: `${eventPrefix}_detalhar_clicked`,
      page_location: pageLocation,
      [keyName]: keyValue,
      timestamp: timestamp == null ? new Date().getTime() : timestamp,
    },
  });
}

export function gtmSendTCODatalayerFilterApplied(
  pageLocation,
  { startDate, endDate, fuelType },
  timestamp = null
) {
  gtmSendDatalayer({
    dataLayer: {
      event: "tco_summary_filter_applied",
      page_location: pageLocation,
      date_start: startDate,
      date_end: endDate,
      fuel_type: fuelType,
      timestamp: timestamp == null ? new Date().getTime() : timestamp,
    },
  });
}

export const gtmPush = (payload) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};